// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner___1POKY","inner--withBanner":"inner--withBanner___2FUQU","innerWithBanner":"inner--withBanner___2FUQU","title":"title___3F5Wl"};